import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';

import hexToRgb from 'styles/hexToRgb';

const styles = theme => ({
  root: {
    position: 'static',
  },
  formControlLabel: {
    position: 'absolute',
    margin: 0,
  },
  radioRoot: {
    width: '100%',
    height: '100%',
    '& *': {
      width: '100%',
      height: '100%',
    },
    '&:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: -2,
      right: -2,
      bottom: -2,
      left: -2,
      zIndex: 1,
    },
  },
  radioIcon: {
    backgroundColor: `rgba(${hexToRgb(theme.palette.grey[900])}, 0.05)`,
    width: '100%',
    height: '100%',
  },
  radioIconChecked: {
    backgroundColor: theme.palette.text.primary,
  },
  radioIconCheckedOutline: {
    backgroundColor: `rgba(${hexToRgb(theme.palette.grey[900])}, 0.05)`,
    border: `1px solid ${theme.palette.text.primary}`,
  },
});

const DocumentPreviewFillRadioField = ({
  input, options, documentPrintWidth, documentPrintHeight, outline, fieldsShift, classes,
}) => (
  <RadioGroup
    className={classes.root}
    {...input}
  >
    {options.map(option => (
      <FormControlLabel
        className={classes.formControlLabel}
        key={option.value}
        value={option.value}
        control={(
          <Radio
            disableRipple
            classes={{
              root: classes.radioRoot,
            }}
            icon={(<div
              className={classes.radioIcon}
            />)}
            checkedIcon={(<div
              className={classNames(classes.radioIconChecked, {
                [classes.radioIconCheckedOutline]: outline,
              })}
            />)}
          />
        )}
        style={{
          left: `${((option.x + fieldsShift.x) / documentPrintWidth) * 100}%`,
          top: `${((option.y + fieldsShift.y) / documentPrintHeight) * 100}%`,
          ...option.width ? { width: `${((option.width / documentPrintWidth) * 100)}%` } : {},
          ...option.height ? { height: `${(option.height / documentPrintHeight) * 100}%` } : {},
        }}
      />
    ))}
  </RadioGroup>
);

DocumentPreviewFillRadioField.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
  }).isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
    value: PropTypes.string,
  })).isRequired,
  documentPrintWidth: PropTypes.number.isRequired,
  documentPrintHeight: PropTypes.number.isRequired,
  outline: PropTypes.bool,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    formControlLabel: PropTypes.string.isRequired,
    radioRoot: PropTypes.string.isRequired,
    radioIcon: PropTypes.string.isRequired,
    radioIconChecked: PropTypes.string.isRequired,
    radioIconCheckedOutline: PropTypes.string.isRequired,
  }).isRequired,
};

DocumentPreviewFillRadioField.defaultProps = {
  outline: false,
};

export default withStyles(styles)(DocumentPreviewFillRadioField);



// WEBPACK FOOTER //
// ./src/components/common/DocumentPreviewFillForm/DocumentPreviewFillRadioField.js